const error = (state = { isError: false }, action) => {
  if (!action.type.includes('@@redux-form')) {
    const isFailed = action.type.includes('FAILED') && !action.type.includes('SET_SUBMIT_FAILED');
    return { ...state, isError: isFailed };
  }
  return { ...state };
};

export default error;
